import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgThuisBij = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M24.02 6.44H7.14v27.11h16.88z"
    />
    <path
      fill="#F8BADD"
      d="M12.34 20.28a5.29 5.29 0 1 0 0-10.58 5.29 5.29 0 0 0 0 10.58"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M10.4 19.91a5.29 5.29 0 0 1 3 6.86L10.14 35 .3 31.09l3.24-8.2a5.29 5.29 0 0 1 6.86-2.98"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M9.595 14.904a2.602 2.602 0 0 0 4.84 1.912l.93.368a3.602 3.602 0 1 1-6.7-2.648z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="m32.86 36.39-8.84-2.83V6.44l8.84-2.83z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgThuisBij);

export default ForwardRef;
